
import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import Navbar from "../../../components/Navbar.js";
import Select from "react-select";
import Resizer from "react-image-file-resizer";
import LOGO from "../../../assets/images/logo.png";
import {
    locale,
    tokens,
    select_style,
    required,
    // alert
    success,
    success_url,
    alert,
    alert_url,
    // function
    logout,
    number_zero,
    format_date,
    toFixed,
    total,
    validate,
    random_charactor,
    float,
    // api
    GET,
    POST,
    PUT,
    DELETE,
    error_message,
    // storage
    removeStorage,
    getStorage,

    validate_email,
    validate_th,
    validate_en,
    validate_en_number,

    LinktoBase64,
    fieldSorter,
    // component
    DatePicker,
} from "../../../components/CustomComponent.js";

import province from "../../../assets/files/province.json";

import "../../../components/global.js";
import "../../../assets/css/bootstrap.css";
import "../../../assets/css/index.css";

export default class Dashboard extends Component {
    constructor(props) {
        super(props)
        this.state = {
            modal_delete: false,

            loading: false,
            data_prefix: [
                { value: "นาย", label: "นาย" },
                { value: "นาง", label: "นาง" },
                { value: "นางสาว ", label: "นางสาว" },
                { value: "บริษัท", label: "บริษัท" },
            ],
            data_car_type: [
                { value: "รถทั่วไป", label: "รถทั่วไป" },
                { value: "รถในประกัน", label: "รถในประกัน" },
            ],
            data_gear_type: [
                { value: "ธรรมดา", label: "ธรรมดา" },
                { value: "ออโต้", label: "ออโต้" },
            ],
            data_brand: [],
            data_model: [],
            data_insurance: [],
            data_customer: [],

            tab: 1,

            member_id: "",
            member_code: "",
            prefix_name: "",
            full_name: "",
            company_name: "",
            address: "",
            phone_number: "",
            email: "",
            tax_number: "",

            car_id: "",
            record_date: new Date(),
            car_type_1: "",
            brand_id: "",
            model_id: "",
            gear_type: "",
            license_plate: "",
            province: "",
            car_color: "",
            insurance_number: "",
            cassi_number: "",
            engine_number: "",
            company_id: "",
            insurance_file: "",

            car_list: [],

            index: -1

        }
    }
    async componentDidMount() {
        await this.getBrandAll();
        await this.getModelAll();
        await this.getInsuranceAll();
        if (this.props.location.query.id) {
            this.GetById(this.props.location.query.id)
        }
    }
    GetById = async (id) => {
        this.setState({ loading: true });
        let body = {
            page: 0,
            data_search: "",
            member_id: id
        }
        let result = await GET(tokens, "v1/TH/member-info/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result)
            let data = result.data;
            this.setState({
                member_id: data.member_id,
                member_code: data.member_code,
                prefix_name: data.prefix_name ? { value: data.prefix_name, label: data.prefix_name } : "",
                full_name: data.full_name,
                company_name: data.company_name,
                address: data.address,
                phone_number: data.phone_number,
                email: data.email,
                tax_number: data.tax_number,

                car_list: data.car_list.map(item => {
                    return {
                        car_id: item.car_id,
                        brand_id: item.brand_id ? this.state.data_brand.filter(e => e.value === item.brand_id)[0] : "",
                        model_id: item.model_id ? this.state.data_model.filter(e => e.value === item.model_id)[0] : "",
                        company_id: item.insurance_id ? this.state.data_insurance.filter(e => e.value === item.insurance_id)[0] : "",
                        record_date: item.record_date,
                        car_type_1: item.car_type_1 ? this.state.data_car_type.filter(e => e.value === item.car_type_1)[0] : "",
                        car_type_2: item.car_type_2,
                        gear_type: item.gear_type ? this.state.data_gear_type.filter(e => e.value === item.gear_type)[0] : "",
                        license_plate: item.license_plate,
                        province: item.province ? { value: item.province, label: item.province } : "",
                        car_color: item.car_color,
                        insurance_number: item.insurance_number,
                        cassi_number: item.cassi_number,
                        engine_number: item.engine_number,
                        insurance_file: item.insurance_file,
                        car_image_list: item.car_image_list ? item.car_image_list : [],
                    }
                }),
            })
            // this.setState({ data: result.data });
        }
        this.setState({ loading: false });
    }
    getInsuranceAll = async () => {
        let body = {
            page: 0,
            data_search: "",
            company_type: 1,
            company_id: ""
        }
        let result = await GET(tokens, "v1/TH/company-info/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result);
            this.setState({ data_insurance: result.data.map(e => { return { value: e.company_id, label: e.company_name } }) });
        }
    }
    getBrandAll = async () => {
        let body = {
            page: 0,
            data_search: "",
            brand_id: ""
        }
        let result = await GET(tokens, "v1/TH/car-manage/brand/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result);
            this.setState({ data_brand: result.data.map(e => { return { value: e.brand_id, label: e.brand_name } }) });
        }
    }
    getModelAll = async () => {
        let body = {
            page: 0,
            data_search: "",
            model_id: ""
        }
        let result = await GET(tokens, "v1/TH/car-manage/model/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result);
            this.setState({ data_model: result.data.map(e => { return { value: e.model_id, label: e.model_name, brand: e.brand_id } }) });
        }
    }

    Create = async () => {
        if (validate(this.state, ["category_name"])) { return };
        this.setState({ loading: true });
        let body = {
            // ข้อมูลสมาชิก
            prefix_name: this.state.prefix_name ? this.state.prefix_name.value : "",
            full_name: this.state.full_name,
            company_name: this.state.company_name,
            address: this.state.address,
            phone_number: this.state.phone_number,
            email: this.state.email,
            tax_number: this.state.tax_number,
            // ข้อมูลรถ
            car_list: this.state.car_list.map(item => {
                return {
                    brand_id: item.brand_id ? item.brand_id.value : "",
                    model_id: item.model_id ? item.model_id.value : "",
                    company_id: item.company_id ? item.company_id.value : "",
                    record_date: format_date(item.record_date, "yyyy-mm-dd", "en"),
                    car_type_1: item.car_type_1 ? item.car_type_1.value : "",
                    car_type_2: item.car_type_2,
                    gear_type: item.gear_type ? item.gear_type.value : "",
                    license_plate: item.license_plate,
                    province: item.province ? item.province.value : "",
                    car_color: item.car_color,
                    insurance_number: item.insurance_number,
                    cassi_number: item.cassi_number,
                    engine_number: item.engine_number,
                    insurance_file: item.insurance_file,
                    car_image_list: item.car_image_list,
                }
            })
        }
        console.log("BODY:", body)
        let result = await POST(tokens, "v1/TH/member-info/create/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            success_url("/master/list-customer");
        }
        this.setState({ loading: false });
    }
    Update = async () => {
        if (validate(this.state, ["category_name"])) { return };
        this.setState({ loading: true });
        let body = {
            // ข้อมูลสมาชิก
            member_id: this.state.member_id,
            prefix_name: this.state.prefix_name ? this.state.prefix_name.value : "",
            full_name: this.state.full_name,
            company_name: this.state.company_name,
            address: this.state.address,
            phone_number: this.state.phone_number,
            email: this.state.email,
            tax_number: this.state.tax_number,
            // ข้อมูลรถ
            car_list: this.state.car_list.map(item => {
                return {
                    car_id: item.car_id ? item.car_id : "",
                    brand_id: item.brand_id ? item.brand_id.value : "",
                    model_id: item.model_id ? item.model_id.value : "",
                    company_id: item.company_id ? item.company_id.value : "",
                    record_date: item.record_date,
                    car_type_1: item.car_type_1 ? item.car_type_1.value : "",
                    car_type_2: item.car_type_2,
                    gear_type: item.gear_type ? item.gear_type.value : "",
                    license_plate: item.license_plate,
                    province: item.province ? item.province.value : "",
                    car_color: item.car_color,
                    insurance_number: item.insurance_number,
                    cassi_number: item.cassi_number,
                    engine_number: item.engine_number,
                    insurance_file: item.insurance_file,
                    car_image_list: item.car_image_list,
                }
            })
        }
        let result = await PUT(tokens, "v1/TH/member-info/update", body);
        if (result && result.status) {
            success_url("/master/list-customer");
        }
        this.setState({ loading: false });
    }
    clear_form = () => {
        this.setState({
            modal_delete: false,

            loading: false,

            tab: 1,
            record_date: "",
            car_type_1: "",
            brand_id: "",
            model_id: "",
            gear_type: "",
            license_plate: "",
            province: "",
            car_color: "",
            insurance_number: "",
            cassi_number: "",
            engine_number: "",
            company_id: "",
            insurance_file: "",

        })
    }

    import_file = (e) => {
        this.changePhoto(e.target.files[0])
        document.getElementById("file").value = "";
        document.getElementById("file").file = null;
    }
    changePhoto = async (file) => {
         
        if (!file.type.includes("image")) {
            alert("error", "แจ้งเตือน", "ไม่สามารถอัพโหลดไฟล์ได้เนื่องจากไม่รองรับรูปแบบไฟล์");
            return
        }
        let reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = (e) => { }
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                file, 512, 512, "JPG", 100, 0,
                (uri) => {
                    this.setState({ insurance_file: uri.split(",")[1] })
                },
                "base64"
            );
        });
    }
    render() {
        return (
            <div className="w-100 min-vh-100 fade-in">
                {this.state.loading && (<div className="spinner-container"> <div className="loading-spinner"></div> </div>)}
                <Navbar page1="หน้าหลัก" page2="แดชบอร์ด" />
                {/* BODY */}
                <div className="body bg-light min-vh-100 position-relative">
                    <div className="p-3">
                        {/* หัวข้อ และ ปุ่มเพิ่ม */}
                        <div className="d-flex mx-0 align-items-center justify-content-between test mb-2 flex-wrap">
                            <h3 className="mb-2"><b>ข้อมูลลูกค้า</b></h3>
                            <button className="btn btn-outline-orange mx-1" onClick={() => { window.location.href = "/master/list-customer" }}>
                                <span className="icon me-2">{"\uf060"}</span>ย้อนกลับ
                            </button>
                        </div>
                        <div className="w-100 card border-0 rounded-lg p-3  mb-2">
                            <div className="row">
                                <div className="col-6 col-md-4 mb-2">
                                    <label className="mb-2">Code ID:</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        placeholder=""
                                        onChange={(e) => {
                                            if (!float(e.target.value)) {
                                                return
                                            }
                                            this.setState({ member_code: e.target.value })
                                        }}
                                        value={this.state.member_code}
                                        readOnly
                                    />
                                </div>
                                <div className="col-6 col-md-4 mb-2">
                                    <label className="mb-2">คำนำหน้า:</label>
                                    <Select
                                        className="form-control select-search"
                                        styles={select_style}
                                        options={this.state.data_prefix}
                                        onChange={(e) => {
                                            this.setState({ prefix_name: e });
                                        }}
                                        value={this.state.prefix_name}
                                        isClearable
                                    ></Select>
                                </div>
                                <div className="col-6 col-md-4 mb-2">
                                    <label className="mb-2">ชื่อ-สกุล{required}:</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        placeholder=""
                                        onChange={(e) => { this.setState({ full_name: e.target.value }) }}
                                        value={this.state.full_name}
                                    />
                                </div>
                                <div className="col-6 col-md-3 mb-2">
                                    <label className="mb-2">ที่อยู่:</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        placeholder=""
                                        onChange={(e) => { this.setState({ address: e.target.value }) }}
                                        value={this.state.address}
                                    />
                                </div>
                                <div className="col-6 col-md-3 mb-2">
                                    <label className="mb-2">เบอร์โทร{required}:</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        placeholder=""
                                        maxLength={10}
                                        onChange={(e) => {
                                            if (!float(e.target.value)) {
                                                return
                                            }
                                            this.setState({ phone_number: e.target.value })
                                        }}
                                        value={this.state.phone_number}
                                    />
                                </div>
                                <div className="col-6 col-md-3 mb-2">
                                    <label className="mb-2">E-mail:</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        placeholder=""
                                        onChange={(e) => { this.setState({ email: e.target.value }) }}
                                        value={this.state.email}
                                    />
                                </div>
                                <div className="col-6 col-md-3 mb-2">
                                    <label className="mb-2">เลขที่ผู้เสียภาษี:</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        placeholder=""
                                        onChange={(e) => { this.setState({ tax_number: e.target.value }) }}
                                        value={this.state.tax_number}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row" style={{ marginBottom: 100 }}>
                            <div className="col-12 col-lg-6 mb-2">
                                <div className="w-100 card border-0 rounded-lg p-3">
                                    <div className="row">
                                        <div className="col-6 col-md-4">
                                            <label className="mb-2">วันที่ลงข้อมูล:</label>
                                            <DatePicker
                                                className="form-control mb-2"
                                                placeholder="พิมพ์คำค้นหา..."
                                                onChange={(e) => {
                                                    this.setState({ record_date: e });
                                                }}
                                                value={this.state.record_date}
                                                disabled
                                            />
                                        </div>
                                        <div className="col-6 col-md-4">
                                            <label className="mb-2">ประเภทรถ{required}:</label>
                                            <Select
                                                className="form-control select-search"
                                                styles={select_style}
                                                options={this.state.data_car_type}
                                                onChange={(e) => {
                                                    this.setState({ car_type_1: e });
                                                }}
                                                value={this.state.car_type_1}
                                                isClearable
                                            ></Select>
                                        </div>
                                        <div className="col-6 col-md-4">
                                            <label className="mb-2">ยี่ห้อ{required}:</label>
                                            <Select
                                                className="form-control select-search"
                                                styles={select_style}
                                                options={this.state.data_brand}
                                                onChange={(e) => {
                                                    this.setState({ brand_id: e, model_id: null });
                                                }}
                                                value={this.state.brand_id}
                                            ></Select>
                                        </div>
                                        <div className="col-6 col-md-4">
                                            <label className="mb-2">รุ่นรถ{required}:</label>
                                            <Select
                                                className="form-control select-search"
                                                styles={select_style}
                                                options={this.state.data_model.filter(e => !this.state.brand_id || e.brand === this.state.brand_id.value)}
                                                onChange={(e) => {
                                                    this.setState({ model_id: e });
                                                }}
                                                value={this.state.model_id}
                                                isDisabled={!this.state.brand_id}
                                            ></Select>
                                        </div>
                                        <div className="col-6 col-md-4">
                                            <label className="mb-2">ประเภทเกียร์:</label>
                                            <Select
                                                className="form-control select-search"
                                                styles={select_style}
                                                options={this.state.data_gear_type}
                                                onChange={(e) => {
                                                    this.setState({ gear_type: e });
                                                }}
                                                value={this.state.gear_type}
                                                isClearable
                                            ></Select>
                                        </div>
                                        <div className="col-6 col-md-4">
                                            <label className="mb-2">ทะเบียนรถ{required}:</label>
                                            <input
                                                className="form-control mb-2"
                                                type="text"
                                                placeholder=""
                                                onChange={(e) => { this.setState({ license_plate: e.target.value }) }}
                                                value={this.state.license_plate}
                                            />
                                        </div>
                                        <div className="col-6 col-md-4">
                                            <label className="mb-2">จังหวัด:</label>
                                            <Select
                                                className="form-control select-search"
                                                styles={select_style}
                                                options={province.map((item) => { return { value: item.province_name, label: item.province_name } })}
                                                onChange={(e) => {
                                                    this.setState({ province: e });
                                                }}
                                                value={this.state.province}
                                                isClearable
                                            ></Select>
                                        </div>
                                        <div className="col-6 col-md-4">
                                            <label className="mb-2">สีรถ:</label>
                                            <input
                                                className="form-control mb-2"
                                                type="text"
                                                placeholder=""
                                                onChange={(e) => { this.setState({ car_color: e.target.value }) }}
                                                value={this.state.car_color}
                                            />
                                        </div>
                                        <div className="col-6 col-md-4">
                                            <label className="mb-2">เลขกรมธรรม์{this.state.car_type_1 && this.state.car_type_1.value === "รถในประกัน" ? required : null}:</label>
                                            <input
                                                className="form-control mb-2"
                                                type="text"
                                                placeholder=""
                                                onChange={(e) => { this.setState({ insurance_number: e.target.value }) }}
                                                value={this.state.insurance_number}
                                            />
                                        </div>
                                        <div className="col-6">
                                            <label className="mb-2">เลขตัวถัง:</label>
                                            <input
                                                className="form-control mb-2"
                                                type="text"
                                                placeholder=""
                                                onChange={(e) => { this.setState({ cassi_number: e.target.value }) }}
                                                value={this.state.cassi_number}
                                            />
                                        </div>
                                        <div className="col-6">
                                            <label className="mb-2">เลขเครื่องยนต์:</label>
                                            <input
                                                className="form-control mb-2"
                                                type="text"
                                                placeholder=""
                                                onChange={(e) => { this.setState({ engine_number: e.target.value }) }}
                                                value={this.state.engine_number}
                                            />
                                        </div>
                                        <div className="col-12">
                                            <label className="mb-2">บริษัทประกัน{this.state.car_type_1 && this.state.car_type_1.value === "รถในประกัน" ? required : null}:</label>
                                            <Select
                                                className="form-control select-search"
                                                styles={select_style}
                                                options={this.state.data_insurance}
                                                onChange={(e) => {
                                                    this.setState({ company_id: e });
                                                }}
                                                value={this.state.company_id}
                                                isClearable
                                            ></Select>
                                        </div>
                                        <div className="col-12">
                                            <label className="mb-2">อัปโหลดหลักฐาน:</label>
                                            <div className="w-100 mb-2">
                                                {this.state.insurance_file === "" ? (
                                                    <div
                                                        className="w-100 pointer card d-flex align-items-center justify-content-center px-3 py-5 bg-light rounded hpx-200"
                                                        onClick={() => { document.getElementById("file").click() }}
                                                    >
                                                        <label className="icon text-secondary pointer">{"\uf0ee"}</label>
                                                        <label className="text-secondary pointer">อัปโหลดรูปภาพ</label>
                                                    </div>
                                                ) : (
                                                    <div className="w-100 card border-2 border-orange d-flex align-items-center justify-content-center p-2  mb-2">
                                                        <div className="position-relative w-100">
                                                            <img alt="รูปสาขา" src={this.state.insurance_file.includes("https://") ? this.state.insurance_file : "data:image/png;base64," + this.state.insurance_file} className="w-100 rounded overflow-hidden"></img>
                                                            <div className="icon pointer bg-danger text-white position-absolute wpx-30 hpx-30 d-flex justify-content-center align-items-center rounded-circle" style={{ top: -8, right: -8 }} onClick={() => { this.setState({ insurance_file: "" }) }}>
                                                                {"\uf00d"}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                                <input className="d-none" type="file" id="file" accept="image/*" onChange={(e) => { this.import_file(e, "main") }} />
                                            </div>
                                        </div>
                                        <div className="col-6 ms-auto">
                                            <div className="w-100 d-flex">
                                                <div className="w-50 pe-1">
                                                    <button className="btn btn-outline-orange w-100" onClick={() => { this.clear_form() }}>
                                                        ล้างข้อมูล
                                                    </button>
                                                </div>
                                                <div className="w-50 ps-1">
                                                    <button className="btn btn-orange w-100" onClick={() => {
                                                        if (!this.state.car_type_1) {
                                                            alert("warning", "แจ้งเตือน", "กรุณาเลือกประเภทรถ");
                                                            return;
                                                        } else if (!this.state.brand_id) {
                                                            alert("warning", "แจ้งเตือน", "กรุณาเลือกยี่ห้อ");
                                                            return;
                                                        } else if (!this.state.model_id) {
                                                            alert("warning", "แจ้งเตือน", "กรุณาเลือกรุ่นรถ");
                                                            return;
                                                        } else if (!this.state.license_plate) {
                                                            alert("warning", "แจ้งเตือน", "กรุณากรอกทะเบียนรถ");
                                                            return;
                                                        }
                                                        if (this.state.car_type_1 && this.state.car_type_1.value === "รถในประกัน" && !this.state.insurance_number) {
                                                            alert("warning", "แจ้งเตือน", "กรุณากรอกเลขกรมธรรม์");
                                                            return;
                                                        }
                                                        if (this.state.car_type_1 && this.state.car_type_1.value === "รถในประกัน" && !this.state.company_id) {
                                                            alert("warning", "แจ้งเตือน", "กรุณาเลือกบริษัทประกัน");
                                                            return;
                                                        }
                                                        let car_list = this.state.car_list;
                                                        if (this.state.index === -1) {
                                                            car_list.push({
                                                                brand_id: this.state.brand_id,
                                                                model_id: this.state.model_id,
                                                                company_id: this.state.company_id,
                                                                record_date: this.state.record_date,
                                                                car_type_1: this.state.car_type_1,
                                                                car_type_2: "",
                                                                gear_type: this.state.gear_type,
                                                                license_plate: this.state.license_plate,
                                                                province: this.state.province,
                                                                car_color: this.state.car_color,
                                                                insurance_number: this.state.insurance_number,
                                                                cassi_number: this.state.cassi_number,
                                                                engine_number: this.state.engine_number,
                                                                insurance_file: this.state.insurance_file,
                                                                car_image_list: []
                                                            });
                                                        } else {
                                                            car_list[this.state.index] = {
                                                                ...car_list[this.state.index],
                                                                brand_id: this.state.brand_id,
                                                                model_id: this.state.model_id,
                                                                company_id: this.state.company_id,
                                                                record_date: this.state.record_date,
                                                                car_type_1: this.state.car_type_1,
                                                                car_type_2: "",
                                                                gear_type: this.state.gear_type,
                                                                license_plate: this.state.license_plate,
                                                                province: this.state.province,
                                                                car_color: this.state.car_color,
                                                                insurance_number: this.state.insurance_number,
                                                                cassi_number: this.state.cassi_number,
                                                                engine_number: this.state.engine_number,
                                                                insurance_file: this.state.insurance_file,
                                                                car_image_list: []
                                                            }
                                                        }
                                                        this.setState({
                                                            car_list: car_list,
                                                            brand_id: "",
                                                            model_id: "",
                                                            company_id: "",
                                                            record_date: new Date(),
                                                            car_type_1: "",
                                                            car_type_2: "",
                                                            gear_type: "",
                                                            license_plate: "",
                                                            province: "",
                                                            car_color: "",
                                                            insurance_number: "",
                                                            cassi_number: "",
                                                            engine_number: "",
                                                            insurance_file: "",
                                                            car_image_list: "",
                                                            index: -1
                                                        })
                                                        success();
                                                    }}>
                                                        {this.state.index === -1 ? "เพ่ิมข้อมูล" : "แก้ไขข้อมูล"}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-6 mb-2">
                                <div className="w-100 card border-0 rounded-lg p-0" style={{ height: "100%" }}>
                                    <div className="table-responsive">
                                        <table className="table table-borderless table-striped">
                                            <thead className="bg-primary">
                                                <tr>
                                                    <th className="text-center text-white">ทะเบียนรถ</th>
                                                    <th className="text-center text-white">ยี่ห้อรถ</th>
                                                    <th className="text-center text-white">รุ่นรถ</th>
                                                    <th className="text-center text-white">สีรถ</th>
                                                    <th className="text-center text-white">จังหวัด</th>
                                                    <th className="text-center text-white">จัดการ</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.car_list && this.state.car_list.map((item, index) => (
                                                    <tr key={index}>
                                                        <td className="text-center">{item.license_plate ? item.license_plate : "-"}</td>
                                                        <td className="text-center">{item.brand_id ? item.brand_id.label : "-"}</td>
                                                        <td className="text-center">{item.model_id ? item.model_id.label : "-"}</td>
                                                        <td className="text-center">{item.car_color ? item.car_color : "-"}</td>
                                                        <td className="text-center">{item.province ? item.province.value : "-"}</td>
                                                        <td className="text-center">
                                                            <div className="d-flex">
                                                                <div className="pointer wpx-30 hpx-30 rounded bg-primary-light mx-1 d-flex justify-content-center align-items-center"
                                                                    onClick={() => {
                                                                        this.setState({
                                                                            record_date: item.record_date,
                                                                            car_type_1: item.car_type_1,
                                                                            brand_id: item.brand_id,
                                                                            model_id: item.model_id,
                                                                            gear_type: item.gear_type,
                                                                            license_plate: item.license_plate,
                                                                            province: item.province,
                                                                            car_color: item.car_color,
                                                                            insurance_number: item.insurance_number,
                                                                            cassi_number: item.cassi_number,
                                                                            engine_number: item.engine_number,
                                                                            company_id: item.company_id,
                                                                            insurance_file: item.insurance_file,
                                                                            index: index
                                                                        })
                                                                    }}>
                                                                    <label className="pointer icon text-primary p-2">{"\uf044"}</label>
                                                                </div>
                                                                <div className="pointer wpx-30 hpx-30 rounded bg-danger-light mx-1 d-flex justify-content-center align-items-center"
                                                                    onClick={() => {
                                                                        this.setState({
                                                                            modal_delete: true,
                                                                            license_plate: item.license_plate,
                                                                            index: index
                                                                        })
                                                                    }}>
                                                                    <label className="pointer icon text-danger p-2">{"\uf2ed"}</label>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="body w-100 position-fixed bg-white p-3 d-flex align-items-center justify-content-end" style={{ bottom: 0 }}>
                    <button className="btn btn-outline-orange mx-1 px-5" onClick={() => { this.setState({ modal_sub_pay: true }) }}>
                        ยกเลิก
                    </button>
                    <button className="btn btn-orange mx-1 px-5" onClick={() => {
                        if (!this.state.full_name) {
                            alert("warning", "แจ้งเตือน", "กรุณากรอกชื่อ-สกุล");
                            return;
                        } else if (!this.state.phone_number) {
                            alert("warning", "แจ้งเตือน", "กรุณากรอกหมายเลขโทรศัพท์");
                            return;
                        }
                        if (this.props.location.query.id) {
                            this.Update()
                        } else {
                            this.Create()
                        }
                    }}>
                        บันทึก
                    </button>
                </div>
                {/* ลบข้อมูล */}
                <Modal show={this.state.modal_delete} onHide={() => { this.setState({ modal_delete: false }) }}>
                    <Modal.Header> <Modal.Title> <b>ต้องการลบสินค้า</b> </Modal.Title> </Modal.Header>
                    <Modal.Body>
                        <label>
                            ท่านต้องการลบสินค้า “{this.state.license_plate}”
                        </label>
                    </Modal.Body>
                    <Modal.Footer>
                        <label className="mb-2 w-100">
                            หมายเหตุ ไม่สามารถกู้คืนได้
                        </label>
                        <div className="w-100 d-flex">
                            <div className="w-50 pe-1">
                                <button className="btn btn-danger w-100" onClick={() => {
                                    let car_list = this.state.car_list;
                                    car_list.splice(this.state.index, 1);
                                    this.setState({ modal_delete: false })
                                    success();
                                }}>
                                    ลบ
                                </button>
                            </div>
                            <div className="w-50 ps-1">
                                <button className="btn btn-outline-danger w-100" onClick={() => { this.setState({ modal_delete: false }) }}>
                                    ยกเลิก
                                </button>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div >
        )
    }
}
